export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const moduleState = context.rootState[moduleId];
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    // Set labels manually
    setAttribute(context, `${moduleId}_certify`, 'labelText', apiData['certify.label']);
    setAttribute(context, `${moduleId}_submit`, 'text', apiData.submit);
    setAttribute(context, `${moduleId}_error-container`, 'heading', apiData['errorContainer.heading']);
    setAttribute(context, `${moduleId}_error-container`, 'message', apiData['errorContainer.message']);
    setAttribute(context, `${moduleId}_other-agency`, 'labelText', apiData['otherAgency.label']);
    setAttribute(context, `${moduleId}_other-agency`, 'options', apiData['otherAgency.options']);
    setAttribute(context, `${moduleId}_other-agency_details_input-text`, 'labelText', apiData['otherAgency.details.label']);

    context.commit(`${moduleId}/ADD_TRACKED_ERRORS`, [`${moduleId}_certify`], { root: true });
    setAttribute(context, `${moduleId}_error-container`, 'errorsCollectedFrom', moduleState.trackedErrors);
};